import { useState } from "react";
import { Trash2 } from "lucide-react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { AlertDialog, AlertDialogAction, AlertDialogCancel, AlertDialogContent, AlertDialogDescription, AlertDialogFooter, AlertDialogHeader, AlertDialogTitle } from "@/components/ui/alert-dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Panel } from "@/components/crm/Badges";

const PHRASE = "ELIMINAR DATOS DE EJEMPLO";

export const DemoWipePanel = () => {
  const [step, setStep] = useState(0);
  const [text, setText] = useState("");
  const wipe = async () => {
    try {
      const { data } = await api.post("/admin/demo-data/wipe", { confirm: text });
      toast.success(`Datos de ejemplo eliminados (${data.deleted.leads} leads)`);
    } catch (e) { toast.error(errorMessage(e)); }
    setStep(0); setText("");
  };
  return (
    <Panel title="Zona de puesta en marcha" className="mt-6 border-rose-200" testid="demo-wipe-panel">
      <p className="text-sm text-slate-600">Elimina los leads de demostración con sus notas, tareas, actividad, asignaciones y conversaciones. Se conservan usuarios, servicios y datos del centro.</p>
      <Button variant="outline" onClick={() => setStep(1)} className="mt-4 rounded-xl border-rose-300 text-rose-700 hover:bg-rose-50" data-testid="demo-wipe-button">
        <Trash2 className="mr-1.5 h-4 w-4" /> Eliminar datos de ejemplo
      </Button>
      <AlertDialog open={step === 1} onOpenChange={(o) => !o && setStep(0)}>
        <AlertDialogContent data-testid="demo-wipe-confirm-1">
          <AlertDialogHeader>
            <AlertDialogTitle>¿Eliminar los datos de ejemplo?</AlertDialogTitle>
            <AlertDialogDescription>Esta acción no se puede deshacer.</AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction onClick={(e) => { e.preventDefault(); setStep(2); }} data-testid="demo-wipe-continue">Continuar</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
      <AlertDialog open={step === 2} onOpenChange={(o) => !o && setStep(0)}>
        <AlertDialogContent data-testid="demo-wipe-confirm-2">
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmación final</AlertDialogTitle>
            <AlertDialogDescription>Escribe <b>{PHRASE}</b> para confirmar.</AlertDialogDescription>
          </AlertDialogHeader>
          <Input value={text} onChange={(e) => setText(e.target.value)} className="rounded-xl" data-testid="demo-wipe-input" />
          <AlertDialogFooter>
            <AlertDialogCancel>Cancelar</AlertDialogCancel>
            <AlertDialogAction disabled={text !== PHRASE} onClick={wipe} className="bg-rose-600 hover:bg-rose-700" data-testid="demo-wipe-final">Eliminar definitivamente</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </Panel>
  );
};
